import Burrow from './../components/Burrow.jsx';

const BurrowPage = () => {
  return (
    <div>
      <Burrow />
    </div>
  )
}

export default BurrowPage